/**
 * FikoGDTAnnotator - GD&T Feature Control Frame (FCF) sembollerini sahnede
 * yönetir (yerleştir / temizle). FikoGDTSymbol render hazır; bu sınıf yaşam
 * döngüsünü (lifecycle) yönetir: yeni ölçümde eskileri temizler, dialog
 * kapanınca hepsini dispose eder. Bellek sızıntısını önler.
 */

import * as THREE from 'three';
import { FikoGDTSymbol, FCFConfig, GDTSymbolType } from '../dimension/advanced/FikoGDTSymbol';

export interface GDTAnnotation {
  symbolType: GDTSymbolType;
  /** FCF kutusunda gösterilecek değer (ölçülen sapma, mm) */
  tolerance: number;
  /** World-space bağlantı (leader ok) noktası */
  attachPoint: THREE.Vector3;
  datumRefs?: string[];
  diameter?: boolean;
}

export class FikoGDTAnnotator {
  private semboller: FikoGDTSymbol[] = [];

  /** @param grup Sembollerin ekleneceği sahne grubu (örn. fikoOlcumlerGrubu) */
  constructor(private grup: THREE.Object3D | null) {}

  setGrup(grup: THREE.Object3D | null): void {
    this.grup = grup;
  }

  /** Önceki sembolleri temizleyip yeni FCF setini yerleştir */
  goster(annots: GDTAnnotation[]): void {
    this.temizle();
    if (!this.grup) return;

    for (const a of annots) {
      if (!a.attachPoint) continue;
      const cfg: FCFConfig = {
        symbolType: a.symbolType,
        tolerance: a.tolerance,
        datumRefs: a.datumRefs,
        diameter: a.diameter,
      };
      try {
        const sym = new FikoGDTSymbol(cfg, a.attachPoint.clone());
        this.grup.add(sym);
        this.semboller.push(sym);
      } catch {
        // tekil sembol hatası diğerlerini engellemesin
      }
    }
  }

  /** Tüm FCF sembollerini sahneden kaldır ve dispose et */
  temizle(): void {
    for (const s of this.semboller) {
      this.grup?.remove(s);
      try { s.dispose(); } catch { }
    }
    this.semboller = [];
  }

  get sayi(): number {
    return this.semboller.length;
  }
}

// ==================== TİP EŞLEME YARDIMCILARI ====================

/** GD&T sonuç türünü FikoGDTSymbol enum'una çevir */
export const GDT_SEMBOL = {
  flatness: GDTSymbolType.FLATNESS,
  diklik: GDTSymbolType.PERPENDICULARITY,
  paralellik: GDTSymbolType.PARALLELISM,
  acisallik: GDTSymbolType.ANGULARITY,
  dairesellik: GDTSymbolType.CIRCULARITY,
  silindiriklik: GDTSymbolType.CYLINDRICITY,
  runout: GDTSymbolType.TOTAL_RUNOUT,
  konsantriklik: GDTSymbolType.CONCENTRICITY,
} as const;
